__turbopack_context__.v({
  "bottomSheet": "w-L9uq_bottomSheet",
  "m1spec": "w-L9uq_m1spec",
  "media": "w-L9uq_media",
  "root": "w-L9uq_root",
});
